import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { cn } from '@cocoonspace/ui/lib/utils'

import { TIME_SLOT_HEIGHT } from './helpers'
import type { BookingOption } from '../step-time'

export const GridDurationRow = ({
	rowTime,
	isAvailable,
	value,
}: {
	rowTime: string
	isAvailable?: boolean
	value: BookingOption
}) => {
	const isHalfHour = rowTime.includes(':30')

	const startAsMinutes = dateTimeUtils.utils.getTimeAsMinutes(value.start)
	const endAsMinutes = dateTimeUtils.utils.getTimeAsMinutes(value.end)
	const rowTimeAsMinutes = dateTimeUtils.utils.getTimeAsMinutes(rowTime)

	const showHalfHour =
		(value.start === rowTime || value.end === rowTime) && isAvailable
	const isHiglighted =
		startAsMinutes <= rowTimeAsMinutes && rowTimeAsMinutes <= endAsMinutes
	const showTime = (isHalfHour && showHalfHour) || !isHalfHour

	return (
		<div
			className={cn(
				'relative w-full border-t border-l bg-white',
				isHalfHour ? 'border-t-transparent' : 'border-t-slate-200',
				isAvailable ? 'border-l-transparent' : 'border-l-primary',
			)}
			data-testid='grid-duration-row'
			style={{
				height: TIME_SLOT_HEIGHT,
				...(!isAvailable && {
					background:
						'linear-gradient(to right bottom,#d1d1d1 6.25%,#ececec 0,#ececec 43.75%,#d1d1d1 0,#d1d1d1 56.25%,#ececec 0,#ececec 93.75%,#d1d1d1 0)',
					backgroundSize: '4.25px 4.25px',
				}),
			}}
		>
			{showTime && (
				<p
					className={cn(
						'!text-xxs absolute -left-10 w-[26px] text-right select-none',
						{
							'text-primary': isHiglighted,
							'text-slate-400': !isAvailable,
						},
					)}
					style={{ top: `${-TIME_SLOT_HEIGHT / 2}px` }}
				>
					{isHalfHour ? ':30' : rowTime}
				</p>
			)}
		</div>
	)
}
